import {ActionBuilder} from "co-redux-builders";

export default ActionBuilder.build({

    onSelectAlertTypeId: (alertTypeId: string) => ({alertTypeId}),
    onSelectAlertSourceId: (alertSourceId: string) => ({alertSourceId}),

    clearNotificationListFilterReducer: () => ({}),
});